<template>
  <div class="chartElem">
    <div class="row">
      <highcharts class="chart" :options="chartOptions" :updateArgs="updateArgs"></highcharts>
    </div>
  </div>
</template>

<script>
export default {
    name: "BarrasH",
    data: () => ({
      cursos: [
            'Materno',
            'Niño',
            'Adolescente',
            'Joven',
            'Adulto',
            'Adulto Mayor', 
        ],
        titulos: [
            'Cuidado Integral de la Gestante',
            'Cuidado Integral del Niño',
            'Cuidado Integral del Adolescente',
            'Cuidado Integral del Joven',
            'Cuidado Integral del Adulto',
            'Cuidado Integral del Adulto Mayor', 
        ],
        grupos: [
            'NEONATO',
            'MENOR DE 1 AÑO',
            '1 AÑO',
            '2 AÑOS',
            '3 AÑOS',
            '4 AÑOS',
            'DE 5 a 11 AÑOS',
            '36 MESES'
        ],
      title: '',
      seriesColor: 'red',
      colorInputIsSupported: null,
      animationDuration: 1000,
      updateArgs: [true, true, {duration: 1000}],
      chartOptions: {
        chart: {
            type: 'column',
            width: 1500,
            height: 500,
        },
        title: {
            text: 'World\'s largest cities per 2017'
        },
        xAxis: {
            type: 'category',
            labels: {
                style: {
                    fontSize: '13px',
                    fontFamily: 'Verdana, sans-serif'
                }
            }
        },

        yAxis: {
            min: 0,
            title: {
                text: 'Cantidad'
            }
        },

        legend: {
            enabled: false
        },
        tooltip: {
            pointFormat: 'Cantidad: <b>{point.y} </b>'
        },


        series: [{
            dataLabels: {
                enabled: true,
                format: '{point.y}',
                style: {
                    fontSize: '15px',
                    fontFamily: 'Verdana, sans-serif'
                }
            },
            color: 'red',
        }],

        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ['viewFullscreen', 'downloadPNG', 'downloadJPEG', 'downloadPDF']
                }
            }
        },
      },
  }),
  created () {
    this.getIniciar()
  },
  props: ['serie','valor','titulo','titulo2','tituloAvance'],
  watch: {
    title (newValue) {
      this.chartOptions.title.text = newValue
    },
    points (newValue) {
      this.chartOptions.series[0].data = newValue
    },
    chartType (newValue) {
      this.chartOptions.chart.type = newValue.toLowerCase()
    },
    seriesColor (newValue) {
      this.chartOptions.series[0].color = newValue.toLowerCase()
    },
    animationDuration (newValue) {
      this.updateArgs[2].duration = Number(newValue)
    }
  },
  methods: {
    getIniciar() {
        if(this.tituloAvance != ''){
            this.tituloAvance = ' - AVANCE AL MES DE ' + this.tituloAvance.toUpperCase()
        }
      this.chartOptions.title.text = this.titulo2 + ' - ' + this.titulo + this.tituloAvance
      this.chartOptions.xAxis.categories = this.serie
      this.chartOptions.chart.width = window.innerWidth - 100
      this.chartOptions.series[0].data = this.valor
    },
  }
}
</script>
